export default __webpack_public_path__ + "static/media/FORMACORPOREA_ICONA.2f829cda.svg";